
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Bestluxurypginpune() {



    const cardData =
    {
        keyword: 'Best Luxury PG in Pune',
        heading: 'Shree Swami Samarth PG :  Best Luxury PG in Pune',
        headingDescription: 'Shree Swami Samarth PG offers the best luxury PG in Pune, combining comfort, style, and modern amenities to provide residents with a premium living experience. Our luxury PG rooms are fully furnished with elegant interiors, spacious layouts, comfortable bedding, and dedicated study or workspaces to ensure both relaxation and productivity. Residents enjoy top-class facilities such as high-speed WiFi, air-conditioning, 24x7 water supply, CCTV surveillance, biometric access, and hygienic home-cooked meals, creating a safe and hassle-free environment. Located in prime areas of Pune with excellent connectivity to IT parks, colleges, and corporate offices, our PG ensures convenience along with a touch of luxury. With professional housekeeping, disciplined management, and a focus on comfort, Shree Swami Samarth PG stands out as the perfect choice for those seeking a premium yet affordable living solution in Pune.',

        top: 'Top Facilities at Shree Swami Samarth PG ',

"topFacilities": [
  {
    "title": "Premium Fully Furnished Rooms",
    "description": "At Shree Swami Samarth PG, luxury meets comfort with tastefully designed single and twin-sharing rooms that include premium beds, stylish study tables, ergonomic chairs, and spacious wardrobes. Every room is air-conditioned, well-lit, and ventilated, ensuring a sophisticated living environment. The interiors are thoughtfully curated with elegant finishes and modern layouts to give residents a sense of exclusivity. With plush furnishings and carefully crafted details, these rooms are ideal for students and professionals who prefer high-end comfort while living in Pune."
  },
  {
    "title": "Gourmet and Hygienic Meals",
    "description": "Luxury living goes hand-in-hand with healthy eating at this PG, where residents are served freshly prepared gourmet-style meals daily. The menu is designed to balance nutrition and taste, offering a variety of cuisines prepared under strict hygiene standards. Residents enjoy home-style comfort food along with occasional treats to make their dining experience exciting. Special dietary preferences are also catered to, ensuring inclusivity for everyone. With meals provided at set times, residents no longer have to worry about cooking or depending on outside food, giving them the true experience of worry-free luxury living."
  },
  {
    "title": "Unmatched Safety and 24/7 Security",
    "description": "Safety is a top priority at Shree Swami Samarth Luxury PG in Pune. The property is equipped with advanced biometric entry systems, round-the-clock CCTV monitoring, and professional on-site staff to ensure complete security. Strict visitor protocols maintain privacy and peace for all residents, making it a trusted choice for parents sending their children to Pune. Located in a premium and secure neighborhood, the PG ensures a safe environment at all times. This commitment to safety creates a worry-free lifestyle where residents can focus on academics, work, and personal well-being."
  },
  {
    "title": "High-Speed Wi-Fi and Digital Connectivity",
    "description": "Every luxury PG resident enjoys uninterrupted high-speed Wi-Fi throughout the property, ensuring seamless digital connectivity. Students can easily attend online lectures, complete research, and prepare projects without interruptions. Professionals benefit from smooth video calls, remote work capabilities, and collaborative tasks, all powered by stable internet access. The connection is strong enough to handle multiple devices simultaneously, making it ideal for shared living. With reliable internet around the clock, residents can balance both productivity and entertainment, streaming content or connecting with family and friends without limitations."
  },
  {
    "title": "Daily Housekeeping and Professional Laundry",
    "description": "Cleanliness is a hallmark of luxury living at this PG. Residents enjoy regular housekeeping services that keep their rooms, corridors, and common spaces spotless. Professional laundry services are available, ensuring fresh clothes and hassle-free living for busy students and working professionals. With these essential services handled seamlessly, residents can focus on their studies, careers, or leisure without worrying about daily chores. A hygienic and well-maintained living environment adds to the premium experience, making this PG one of the top choices for those who prioritize health and comfort."
  },
  {
    "title": "Prime Luxury Locations in Pune",
    "description": "Situated in prime areas like Koregaon Park,  Kharadi, and Viman Nagar, the PG offers unmatched accessibility to colleges, IT hubs, shopping malls, and cultural spots. Residents enjoy the convenience of quick commutes to Hinjewadi IT Park, business centers, and educational institutions. The neighborhoods are renowned for their upscale cafés, gyms, wellness centers, and entertainment zones, giving residents a modern and cosmopolitan lifestyle. Living in these luxury PGs not only means convenience but also the privilege of being in Pune’s most sought-after and vibrant areas."
  },
  {
    "title": "Recreational Lounges and Wellness Facilities",
    "description": "Understanding the importance of relaxation, this luxury PG provides dedicated recreational lounges with modern interiors, TV entertainment zones, and indoor games. Fitness enthusiasts benefit from in-house gyms and wellness areas designed to support a balanced lifestyle. Meditation corners and quiet reading spaces offer a tranquil retreat from the hustle of daily life. These amenities create a perfect blend of productivity and leisure, allowing residents to focus on studies or work while still enjoying social bonding and stress relief. It’s more than just accommodation—it’s a lifestyle upgrade."
  },
  {
    "title": "Transparent Pricing with Luxury Benefits",
    "description": "While providing a premium living experience, Shree Swami Samarth PG in Pune ensures transparent and fair pricing with no hidden charges. Residents can choose from flexible options like single occupancy or twin-sharing depending on their budget and comfort preferences. All-inclusive rental packages cover meals, utilities, internet, and housekeeping, making luxury living more convenient and stress-free. This model provides residents with true value for money, making it a top choice for those who want luxury facilities without unnecessary financial strain. It’s affordable elegance designed for today’s youth."
  }
],


"services": [
  {
    "name": "Best Luxury PG in Pune",
    "description": "Shree Swami Samarth PG is widely recognized as one of the best luxury PGs in Pune, offering a high-end residential experience for those who value comfort, style, and convenience. Located in prime areas such as  Aundh, and Hinjewadi, our PG combines hotel-like living with the homely touch of personal care. Residents enjoy top-tier amenities like fully furnished air-conditioned rooms, biometric entry, daily housekeeping, high-speed Wi-Fi, nutritious meals, and round-the-clock security. Whether you're a student from a top-tier university or a working professional at an MNC, our luxury PG is designed to elevate your living standards in the city."
  },
  {
    "name": "Premium PG in Pune",
    "description": "Step into elegance at Shree Swami Samarth’s premium PG in Pune. Our facilities go beyond the ordinary, with designer interiors, spacious layouts, personal balconies (in select units), RO water, and on-demand laundry service. Residents enjoy seamless access to transport hubs, IT parks like EON IT Park and Rajiv Gandhi Infotech Park, and top colleges. The environment is serene, secure, and community-friendly, making it ideal for professionals and students who desire a sophisticated yet affordable stay."
  },
  {
    "name": "High-End PG in Pune",
    "description": "Experience next-level comfort with our high-end PG accommodations in Pune. Shree Swami Samarth PG offers ultra-modern rooms equipped with ambient lighting, smart TVs, ergonomic study spaces, plush bedding, and en-suite bathrooms. Our premium package includes chef-curated meals, laundry, Wi-Fi, and regular room sanitization. Strategically located near corporate corridors and elite academic institutions, this PG suits executives, business travelers, and students looking for quality housing without compromise."
  },
  {
    "name": "Luxury PG with AC in Pune",
    "description": "Stay cool and classy with Shree Swami Samarth PG’s luxury PG with AC rooms in Pune. Each room is climate-controlled, elegantly furnished, and designed for maximum comfort. Whether you’re coming back from a long workday or preparing for exams, enjoy a peaceful and rejuvenating ambiance. AC rooms come with inverter backup, double glazing for noise reduction, and blackout curtains for restful sleep."
  },
  {
    "name": "Furnished Luxury PG in Pune",
    "description": "Our furnished luxury PG rooms in Pune come ready-to-live, featuring premium quality beds, soft-close wardrobes, wall-mounted shelves, bedside lighting, and attached washrooms. At Shree Swami Samarth PG, you don’t need to bring anything except your clothes. Everything else—from linen to cutlery—is provided. Our fully managed facility includes deep-cleaning services, security personnel, and curated social events for community engagement."
  },
  {
    "name": "Luxury Single Room PG Pune",
    "description": "Need your own space? Shree Swami Samarth offers exclusive luxury single room PG options in Pune, perfect for individuals who seek privacy without sacrificing lifestyle. Each room includes a queen-sized bed, personal study area, AC, smart lighting, and elegant decor. Ideal for working professionals, digital nomads, and students who value peace and productivity. Choose from flexible rental packages, including monthly, quarterly, and yearly stays."
  },
  {
    "name": "Luxury PG for Girls in Pune",
    "description": "Shree Swami Samarth’s luxury girls PG in Pune is thoughtfully designed for female residents, prioritizing safety, comfort, and community. With women-only floors, 24/7 security, biometric access, and female staff, it ensures complete peace of mind. The rooms are fully furnished with stylish décor, AC, study desks, and personal wardrobes. Additional perks include curated meals, yoga/fitness areas, and access to women’s networking events within the PG community."
  },
  {
    "name": "Executive PG in Pune",
    "description": "For senior professionals and corporate employees, Shree Swami Samarth PG offers executive PG accommodations in Pune that match the standards of an upscale hotel. Think wood-panelled walls, in-room workstations, high-speed LAN connectivity, and quiet hours. Perfectly suited for mid- to long-term stays, the executive PG model includes custom meal plans, weekend housekeeping, and proximity to key business parks like Magarpatta and World Trade Center."
  },
  {
    "name": "Luxury Boys PG in Pune",
    "description": "Our luxury PG for boys in Pune is tailor-made for students and young professionals who expect both style and substance. Located near major IT hubs and campuses, the PG offers fully furnished, air-conditioned rooms with modern interiors and premium services. From high-speed internet and laundry to nutritious meals and 24/7 support, Shree Swami Samarth PG makes every stay feel first-class."
  },
  {
    "name": "Top Luxury PG Pune",
    "description": "Ranked among the top luxury PG accommodations in Pune, Shree Swami Samarth PG combines modern aesthetics, flawless service, and unmatched convenience. Whether you prefer a single room, shared suite, or studio-style setup, we provide multiple formats to fit your lifestyle. Our guests enjoy concierge service, curated food menus, and proximity to top institutions like Symbiosis, FLAME University, and various tech parks."
  },
  {
    "name": "PG with Amenities in Pune",
    "description": "Amenities matter—and at Shree Swami Samarth PG in Pune, we go above and beyond. From biometric entry, AC, and CCTV to fast internet, laundry, meals, recreation rooms, and regular community events, every detail is curated for comfort. We don’t just provide a room—we offer a lifestyle that’s safe, smart, and convenient. Ideal for students, freelancers, or professionals on flexible work schedules."
  }
],
"tableData": [
  ["Best Luxury PG in Pune", "Premium PG in Pune"],
  ["High-End PG in Pune", "Luxury PG with AC in Pune"],
  ["Furnished Luxury PG in Pune", "Luxury Single Room PG Pune"],
  ["Luxury PG for Girls in Pune", "Executive PG in Pune"],
  ["Luxury Boys PG in Pune", "Top Luxury PG Pune"],
  ["PG with Amenities in Pune", ""]
],




"whychoose": [
    {
        "WhyChooseheading": "Best Luxury PG in Pune with Premium Living Standards",
        "WhyChoosedescription": "Shree Swami Samarth PG redefines modern-day coliving with its best-in-class luxury PG experience in Pune. Our premium PG offers a blend of style, privacy, and convenience—perfect for young professionals, corporate employees, and students seeking more than just a place to stay. Enjoy high-end interiors, curated amenities, and an elevated lifestyle in the heart of the city."
    },
    {
        "WhyChooseheading": "Designer Rooms with Hotel-Like Comfort",
        "WhyChoosedescription": "Each room is thoughtfully designed with elegant décor, soft lighting, ergonomic furniture, and top-quality mattresses. Residents enjoy amenities like smart TVs, personal refrigerators, en-suite bathrooms, air conditioning, and wooden flooring—bringing the feel of boutique living into PG accommodation."
    },
    {
        "WhyChooseheading": "Prime Locations Near Business and Leisure Hubs",
        "WhyChoosedescription": "Located in Pune’s most desirable areas—such as Koregaon Park,  Viman Nagar, and Kalyani Nagar—our luxury PG accommodations provide quick access to business parks, nightlife, cafes, gyms, and malls. Whether you work in IT or the creative industry, you're never far from work or recreation."
    },
    {
        "WhyChooseheading": "Gourmet Meals and On-Demand Dining",
        "WhyChoosedescription": "Our in-house chefs prepare fresh, multi-cuisine meals daily—from healthy breakfasts to hearty dinners. We offer veg and non-veg options with a focus on taste, nutrition, and hygiene. Special weekend menus, evening snacks, and custom diet meals are available on request for residents with specific needs."
    },
    {
        "WhyChooseheading": "State-of-the-Art Facilities and Services",
        "WhyChoosedescription": "From high-speed fiber internet and daily laundry service to professional housekeeping and power backup, every detail is handled with care. Additional amenities include lounge areas, coffee machines, reading corners, fitness zones, and rooftop common areas for socializing and relaxation."
    },
    {
        "WhyChooseheading": "Unmatched Safety, Privacy, and Hygiene",
        "WhyChoosedescription": "Our PGs are protected by biometric access, CCTV surveillance, fire safety systems, and on-site security. Rooms are sanitized regularly, and our staff is trained to maintain the highest cleanliness and hygiene standards—giving you a secure and private environment to live in."
    },
    {
        "WhyChooseheading": "Flexible Lease Terms with Hassle-Free Billing",
        "WhyChoosedescription": "Enjoy flexible rental plans—monthly or long-term—with transparent, all-inclusive pricing. No brokerage, no hidden charges. Rent covers food, Wi-Fi, laundry, electricity, and all facilities. Digital invoices and GST-compliant billing are provided for ease of tracking and reimbursements."
    },
    {
        "WhyChooseheading": "Concierge Services and 24/7 Support",
        "WhyChoosedescription": "Experience true luxury living with our dedicated support team available around the clock for any need—be it maintenance requests, travel assistance, or package delivery. Our on-site managers and service staff ensure your daily life runs smoothly with minimum effort from your end."
    }
]




















    }

const faqData = [
    {
        question: "How can I book the best luxury PG in Pune at Shree Swami Samarth PG?",
        answer: "You can book a luxury PG room at Shree Swami Samarth PG in Pune by calling us directly or scheduling a visit. Premium bookings can also be arranged online."
    },
    {
        question: "What makes Shree Swami Samarth PG one of the best luxury PGs in Pune?",
        answer: "We offer fully furnished rooms with modern interiors, high-speed Wi-Fi, air-conditioning, attached bathrooms, professional housekeeping, and top-tier security for a luxury living experience."
    },
    {
        question: "Are meals included in the luxury PG package?",
        answer: "Yes, our luxury PG plan includes chef-prepared vegetarian meals—served fresh and hygienically, three times a day."
    },
    {
        question: "Do you offer single occupancy rooms in your luxury PG in Pune?",
        answer: "Yes, we offer exclusive single occupancy rooms with premium furnishings, perfect for working professionals and students seeking privacy and comfort."
    },
    {
        question: "Is your luxury PG in Pune suitable for both boys and girls?",
        answer: "Absolutely. We offer separate luxury accommodations for boys and girls, with all the premium facilities tailored to their needs."
    },
    {
        question: "What additional amenities are available in the luxury PG at Shree Swami Samarth PG?",
        answer: "Luxury amenities include AC rooms, 24/7 power backup, laundry services, elevator access, smart TV (in select rooms), and dedicated study/workspaces."
    },
    {
        question: "What is the monthly rent for the best luxury PG in Pune?",
        answer: "The rent depends on occupancy (single/double) and room features. Please contact us for the latest pricing and available packages."
    },
    {
        question: "Is there a minimum stay requirement for luxury PG residents?",
        answer: "Yes, a minimum stay of one month is required. Long-term residents can enjoy additional perks and priority services."
    },
    {
        question: "Do you offer pick-up or welcome services for new residents?",
        answer: "Yes, for luxury PG bookings, we provide a complimentary welcome kit and assistance with shifting/luggage handling."
    },
    {
        question: "How can I contact Shree Swami Samarth PG for luxury PG bookings in Pune?",
        answer: "To book or inquire about our best luxury PG in Pune, please call us at +91 9594917913. Property visits and virtual tours are available on request."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Karan Jadhav',
        designation: 'Senior Software Engineer, Infosys Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“This is hands down the best luxury PG I’ve stayed at in Pune. From the quality of food to the polished rooms and services—everything feels like home with a hotel vibe.”',
    },
    {
        name: 'Ms. Aishwarya Bhosale',
        designation: 'Design Intern, FID Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“A truly luxurious PG experience! Spacious AC rooms, great food, and the ambiance is amazing. Perfect for students who don’t want to compromise on comfort.”',
    },
];

















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9209169761",
            "+91 9096665072",

        ],
        email: "reservation@swamisamarthpg.com "
    };


     const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " PG in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "  Single Room PG in Pune",
        },
        
        {
            place: "/images/keyword/4.jpg",
            text: "  Best Luxury PG in Pune",
        },
       
       
        {
            place: "/images/keyword/13.jpg",
            text: "  Hostel in Pune",
        },

        {
            place: "/images/keyword/15.jpg",
            text: " PG for Working Professionals Pune",
        },
        
        {
            place: "/images/keyword/19.jpg",
            text: "  Paying Guest Near Hinjewadi IT Park Pune",
        },
        

    ];


    const images = [
        { src: "./images/gallery/1.jpg", alt: "Image 1" },
        { src: "./images/gallery/2.jpg", alt: "Image 1" },
        { src: "./images/gallery/3.jpg", alt: "Image 1" },
        { src: "./images/gallery/4.jpg", alt: "Image 1" },
        { src: "./images/gallery/5.jpg", alt: "Image 1" },
        { src: "./images/gallery/6.jpg", alt: "Image 1" },
        { src: "./images/gallery/7.jpg", alt: "Image 1" },
        { src: "./images/gallery/8.jpg", alt: "Image 1" },
        { src: "./images/gallery/9.jpg", alt: "Image 1" },

    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best Luxury PG in Pune",
  "image": "https://swamisamarthpg.com/assets/images/luxury-pg-pune.jpg", // Replace with actual image URL
  "description": "Experience premium luxury PG accommodations in Pune with Shree Swami Samarth PG. Fully furnished, AC rooms with top amenities, ideal for executives, girls, and boys seeking comfort and style.",
  "brand": {
    "@type": "Brand",
    "name": "Shree Swami Samarth PG"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1800"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12000",  // Replace with actual price if needed
    "availability": "https://schema.org/InStock",
    "url": "https://swamisamarthpg.com/luxury-pg-pune"  // Replace with actual page URL if different
  }
};




    return (
        <div>


<Helmet>
  <title>Best Luxury PG in Pune | Premium & Furnished PG with AC</title>
  <meta 
    name="description" 
    content="Discover the best luxury PG in Pune at Shree Swami Samarth PG. Fully furnished AC rooms with premium amenities for executives, girls, and boys. Enjoy a high-end PG experience with us." 
  />
  <meta 
    name="keywords" 
    content="Best Luxury PG in Pune, Premium PG in Pune, High-End PG in Pune, Luxury PG with AC in Pune, Furnished Luxury PG in Pune, Luxury Single Room PG Pune, Luxury PG for Girls in Pune, Executive PG in Pune, Luxury Boys PG in Pune, Top Luxury PG Pune, PG with Amenities in Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(images/background/3.jpg)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: 'white'
  }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/4.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF6403', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topFacilities.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                          

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Shree Swami Samarth PG</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                {/* <FAQKeyword faqs={faqData} /> */}
                <Accordion data={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF6403',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF6403' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919209169761" className="d-block  text-white">+91 9209169761</a>
                                                <a href="tel:+919096665072" className="d-block  text-white">+91 9096665072</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF6403' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:reservation@swamisamarthpg.com " className=" text-white d-block">
                                                    reservation@swamisamarthpg.com 
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF6403' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Shree Swami Samarth PG  <br />
                                                        M.No. 03065, No. 258/1/3, Mukai Nagar, B.H. MRF Showroom, Pune 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bestluxurypginpune;